import { config, msg } from 'api';
import { setErrorMessage, setSuccessMessage } from 'apps/notifications/actions/notifications';
import { wa, pageEventTypes } from 'apps/analytics';
import errorHandler from 'lib/utils/errorHandler';

export const SET_SMS_ALERT_SETTINGS = 'SET_SMS_ALERT_SETTINGS';
export const SET_CURRENT_SMS_NUMBER = 'SET_CURRENT_SMS_NUMBER';
export const OPEN_REMOVE_NUMBER_CONFIRM = 'OPEN_REMOVE_NUMBER_CONFIRM';
export const CLOSE_REMOVE_NUMBER_CONFIRM = 'CLOSE_REMOVE_NUMBER_CONFIRM';

export function openRemoveNumberConfirm() {
  return { type: OPEN_REMOVE_NUMBER_CONFIRM };
}

export function closeRemoveNumberConfirm() {
  return { type: CLOSE_REMOVE_NUMBER_CONFIRM };
}

export function setCurrentSmsNumber(smsNumber) {
  return {
    type: SET_CURRENT_SMS_NUMBER,
    currentSmsNumber: smsNumber,
  };
}

export function setSmsAlertSettings(params) {
  return {
    type: SET_SMS_ALERT_SETTINGS,
    ...params,
  };
}

export function saveSmsAlertSettings(smsNumber, showNotification = false) {
  return (dispatch, getState, { network }) =>
    network.put(`${config.apiBasePath}/settings/sms-alerting`, {
      body: JSON.stringify({
        smsNumber,
      }),
    })
      .then(() => {
        wa.triggerPageEvent(pageEventTypes.SMS_ALERTS_SUCCESS_NOTIFICATION_DISPLAYED, {
          REMINDERS_OFF: !smsNumber,
        });
        dispatch(setCurrentSmsNumber(smsNumber));
        if (showNotification) {
          dispatch(setSuccessMessage('Your preferences have been successfully saved'));
        }
        return true;
      })
      .catch(() => {
        wa.triggerPageEvent(pageEventTypes.SMS_ALERTS_ERROR_NOTIFICATION_DISPLAYED, {
          REMINDERS_OFF: !smsNumber,
        });
        dispatch(setErrorMessage(msg.settings.flashMessage.failure));
        return false;
      });
}

export function getSmsAlertSettings() {
  return (dispatch, getState, { network }) =>
    network.get(`${config.apiBasePath}/settings/sms-alerting`)
      .then(response =>
        dispatch(setSmsAlertSettings({
          currentSmsNumber: response.currentSmsNumber,
          primaryNumber: response.primaryNumber,
          secondaryNumber: response.secondaryNumber,
          hasSlotSubscription: response.hasSlotSubscription,
        }))
      )
      .catch(errorHandler);
}
